import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { BuildingOfficeIcon, EnvelopeIcon, PhoneIcon, ScaleIcon } from '@heroicons/react/24/outline';

const LegalNoticePage = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a] py-12">
      <div className="container-custom max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-[#111111] rounded-2xl border border-[#252525] overflow-hidden"
        >
          {/* Header */}
          <div className="bg-gradient-to-r from-[#F97316] to-[#e8630a] px-8 py-10 text-white">
            <h1 className="text-3xl lg:text-4xl font-display font-bold mb-2">
              Mentions légales
            </h1>
            <p className="text-white/80 text-lg">
              Informations légales de la plateforme VADOM
            </p>
            <div className="mt-4 flex items-center gap-2 text-sm text-white/70">
              <ScaleIcon className="h-5 w-5" />
              <span>Conformément à la législation en vigueur</span>
            </div>
          </div>

          {/* Content */}
          <div className="p-8 space-y-8">
            {/* Éditeur */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-4 flex items-center gap-2">
                <BuildingOfficeIcon className="h-5 w-5 text-[#F97316]" />
                Éditeur du site
              </h2>
              <div className="bg-[#0a0a0a] rounded-xl p-5 space-y-2 text-[#AAAAAA]">
                <p><span className="text-white font-medium">Raison sociale :</span> VADOM SAS</p>
                <p><span className="text-white font-medium">Forme juridique :</span> Société par Actions Simplifiée</p>
                <p><span className="text-white font-medium">Capital social :</span> 10.000.000 FCFA</p>
                <p><span className="text-white font-medium">RCCM :</span> TG-LOM-2024-0001</p>
                <p><span className="text-white font-medium">N° IFU :</span> 1234567890A</p>
                <p><span className="text-white font-medium">Siège social :</span> Lomé, Togo</p>
                <p><span className="text-white font-medium">Email :</span> <a href="mailto:vadomxpress@gmail.com" className="text-[#F97316] hover:underline">vadomxpress@gmail.com</a></p>
                <p><span className="text-white font-medium">Téléphone :</span> +228 XX XX XX XX</p>
              </div>
            </section>

            {/* Directeur de publication */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">Directeur de publication</h2>
              <div className="bg-[#0a0a0a] rounded-xl p-5 text-[#AAAAAA]">
                <p><span className="text-white font-medium">Nom :</span> Mensah Koffi EATSU</p>
                <p><span className="text-white font-medium">Fonction :</span> CEO & Co-fondateur</p>
                <p><span className="text-white font-medium">Email :</span> <a href="mailto:vadomxpress@gmail.com" className="text-[#F97316] hover:underline">vadomxpress@gmail.com</a></p>
              </div>
            </section>

            {/* Hébergement */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">Hébergement</h2>
              <div className="bg-[#0a0a0a] rounded-xl p-5 text-[#AAAAAA]">
                <p><span className="text-white font-medium">Nom :</span> [Nom de l'hébergeur]</p>
                <p><span className="text-white font-medium">Adresse :</span> [Adresse de l'hébergeur]</p>
                <p><span className="text-white font-medium">Téléphone :</span> [Téléphone de l'hébergeur]</p>
                <p><span className="text-white font-medium">Email :</span> [Email de l'hébergeur]</p>
              </div>
            </section>

            {/* Propriété intellectuelle */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">Propriété intellectuelle</h2>
              <div className="bg-[#0a0a0a] rounded-xl p-5 text-[#AAAAAA] space-y-3">
                <p>
                  L'ensemble des éléments composant la plateforme VADOM (textes, logos, images, 
                  vidéos, code source, design, etc.) sont la propriété exclusive de VADOM SAS 
                  ou de ses partenaires, et sont protégés par le droit d'auteur et la propriété 
                  intellectuelle.
                </p>
                <p>
                  Toute reproduction, représentation, modification, publication, adaptation 
                  de tout ou partie des éléments de la plateforme, quel que soit le moyen ou 
                  le procédé utilisé, est interdite, sauf autorisation écrite préalable de VADOM SAS.
                </p>
                <p>
                  <span className="text-white font-medium">Marque VADOM :</span> marque déposée auprès de l'OAPI.
                </p>
              </div>
            </section>

            {/* Protection des données */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">Protection des données personnelles</h2>
              <div className="bg-[#0a0a0a] rounded-xl p-5 text-[#AAAAAA] space-y-3">
                <p>
                  Conformément à la loi sur la protection des données, vous disposez d'un droit 
                  d'accès, de rectification et de suppression de vos données personnelles.
                </p>
                <p>
                  Pour exercer ces droits ou pour toute question sur le traitement de vos données, 
                  consultez notre <Link to="/legal/privacy" className="text-[#F97316] hover:underline">Politique de confidentialité</Link> 
                  ou contactez notre DPO à <a href="mailto:vadomxpress@gmail.com" className="text-[#F97316] hover:underline">vadomxpress@gmail.com</a>.
                </p>
              </div>
            </section>

            {/* Cookies */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">Cookies</h2>
              <div className="bg-[#0a0a0a] rounded-xl p-5 text-[#AAAAAA]">
                <p>
                  La plateforme VADOM utilise des cookies pour faciliter votre navigation. 
                  Vous pouvez gérer vos préférences via les paramètres de votre navigateur. 
                  Pour en savoir plus, consultez notre <Link to="/legal/cookies" className="text-[#F97316] hover:underline">Politique des cookies</Link>.
                </p>
              </div>
            </section>

            {/* Responsabilité */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">Limitation de responsabilité</h2>
              <div className="bg-[#0a0a0a] rounded-xl p-5 text-[#AAAAAA]">
                <p>
                  VADOM s'efforce de garantir l'exactitude des informations diffusées sur sa plateforme. 
                  Cependant, VADOM ne peut garantir l'exhaustivité ou l'absence de modification par un tiers. 
                  La responsabilité de VADOM ne saurait être engagée en cas d'erreur, d'omission ou de 
                  résultat obtenu suite à l'utilisation des informations fournies sur la plateforme.
                </p>
              </div>
            </section>

            {/* Contact */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">Contact</h2>
              <div className="bg-[#0a0a0a] rounded-xl p-5 space-y-2">
                <p className="text-white">📧 <a href="mailto:vadomxpress@gmail.com" className="hover:text-[#F97316] transition">vadomxpress@gmail.com</a></p>
                <p className="text-white">📍 VADOM SAS, Lomé, Togo</p>
                <p className="text-white">🌐 <Link to="/contact" className="hover:text-[#F97316] transition">Formulaire de contact</Link></p>
              </div>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default LegalNoticePage;